import { SET_CURRENT_PLACE, SET_CHILDREN, SET_MAIN_PLACE, SET_HEADERS, SET_LAYOUT } from "../actions/treeLevelActions";
import type { TreeLevelAction } from "../actions/treeLevelActions";
import type { TreeLevelState } from "../../types/redux";

const initialState: TreeLevelState = {
    mainPlace: null, 
    currPlace: -1,
    parentId: -1,
    childrenIds: [],
    currentTitle: '',
    currentSubtitle: '',
    currentLayout: ''
}

const treeLevelReducer = (state: TreeLevelState = initialState, action: TreeLevelAction): TreeLevelState => {
    switch (action.type) {
        case SET_MAIN_PLACE:
            return {
                ...state, mainPlace: action.payload
            }
        case SET_CURRENT_PLACE:
            return {
                ...state,
                currPlace: action.payload.currPlace || state.currPlace,
                childrenIds: action.payload.children_list?.length ? action.payload.children_list : state.childrenIds,
                parentId: action.payload.parentId || -1,
                currentTitle: action.payload.title || state.currentTitle,
                currentSubtitle: action.payload.subtitle || state.currentSubtitle
            }
        case SET_CHILDREN:
            return {
                ...state,
                childrenIds: action.payload.length > 0 ? action.payload : state.childrenIds
            }
        case SET_HEADERS:
            return {
                ...state,
                currentTitle: action.payload.title,
                currentSubtitle: action.payload.subtitle
            }
        case SET_LAYOUT:
            return {
                ...state,
                currentLayout: action.payload
            }
        default:
            return state;
    }
}

export default treeLevelReducer;
